import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    const run = async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sid, ref: localStorage.getItem("bz_ref") || null });
        localStorage.removeItem("bz_ref");
        setUser(data);
        window.history.replaceState(null, "", "/app");
        navigate("/app", { replace: true });
      } catch {
        toast.error("Accesso non riuscito, riprova.");
        navigate("/", { replace: true });
      }
    };
    run();
  }, [location.hash, navigate, setUser]);

  return null;
};
